import React from "react";
import { useNavigate } from "react-router-dom";
import { getPreferredCategoryPath } from "../utils/locationStorage";

export default function ProjectCard({ icon, title, slug }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!slug) return;
    try {
      navigate(getPreferredCategoryPath(slug));
    } catch (err) {
      navigate(`/in-town/${slug}`);
    }
  };

  return (
    <button
      className="projectCard"
      type="button"
      onClick={handleClick}
    >
      <div className="projectIcon">{icon}</div>
      <div className="projectCardTitle">{title}</div>
    </button>
  );
}
